import { render, staticRenderFns } from "./EmploymentSLRList.vue?vue&type=template&id=023eeda9&scoped=true&"
import script from "./EmploymentSLRList.vue?vue&type=script&lang=ts&"
export * from "./EmploymentSLRList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023eeda9",
  null
  
)

export default component.exports